import { Immutable } from "immer";
import React from "react";

import type { HiddenAnchorLinkBlock as Value } from "@reactivated";

/**
 * Faithful port of the legacy server-rendered
 * ``cms/components/hidden-anchor-link.html``: ``<span id="{{ value }}"></span>``.
 * ``value`` is the anchor id string (the block is a bare ``CharBlock`` ->
 * ``HiddenAnchorLinkBlock = string`` in the generated types). It produces an
 * empty, invisible in-page anchor target for jump links.
 */
type IProps = Immutable<{
    value: Value;
}>;

export const HiddenAnchorLinkBlock = (props: IProps): React.JSX.Element => {
    return <span id={props.value} />;
};
